var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-chevron-right-2';
                    var viewUrl = 'sprite.svg#view-icon-chevron-right-2';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 10 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };